import React, { useEffect, useState } from 'react';
import { Input } from '../../../components/ui/Input';
import Btn from '../../../components/ui/Btn';

export default function ContatosTab({ registroId, api }) {
  const [contatos, setContatos] = useState([]);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!registroId) return;
    api.obterContatos(registroId).then(setContatos).catch(() => {});
  }, [registroId]); // eslint-disable-line

  if (!registroId) return <p style={{ color: '#697180', fontSize: 14 }}>Salve o cadastro na aba Dados Gerais antes de adicionar contatos.</p>;

  const adicionar = () => setContatos(c => [...c, { nome: '', telefone: '', email: '', cargo: '' }]);
  const remover = (idx) => setContatos(c => c.filter((_, i) => i !== idx));
  const atualizar = (idx, campo, valor) => setContatos(c => c.map((item, i) => i === idx ? { ...item, [campo]: valor } : item));

  const salvar = async () => {
    setSalvando(true);
    try {
      await api.salvarContatos(registroId, contatos.filter(c => c.nome));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {contatos.map((c, idx) => (
          <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1.5fr 1fr auto', gap: 10, alignItems: 'end' }}>
            <Input label="Nome" value={c.nome} onChange={e => atualizar(idx, 'nome', e.target.value)} />
            <Input label="Telefone" value={c.telefone} onChange={e => atualizar(idx, 'telefone', e.target.value)} />
            <Input label="Email" type="email" value={c.email} onChange={e => atualizar(idx, 'email', e.target.value)} />
            <Input label="Cargo" value={c.cargo} onChange={e => atualizar(idx, 'cargo', e.target.value)} />
            <Btn variante="danger" tamanho="sm" onClick={() => remover(idx)}>Remover</Btn>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 14, display: 'flex', gap: 10 }}>
        <Btn variante="secondary" onClick={adicionar}>+ Adicionar Contato</Btn>
        <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar Contatos'}</Btn>
      </div>
    </div>
  );
}
